import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page47() {
  useEffect(() => {
    document.title = "Маяк — Страница 46"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page45" />
        <ForwardLink href="/page47" />
      </div>

      <p style={{ textAlign: "right" }}>46.</p>
      <p>
        Повернув за угол, он видит что-то БЕЛОЕ в черных<br/>
        камнях берега... Делает еще несколько шагов...
      </p>
      <p>Это ТЕЛО, лежащее неподвижно. <i>Мертвый моряк?</i></p>
      <p>Он задыхается... Роняет тачку и бежит к нему!</p>
      <p>ФОГОРН ревет.</p>
      <p>
        Когда он приближается, кажется, что это ЖЕНЩИНА... ГОЛУЮ ЖЕНЩИНУ<br/>
        выбросило на камни. Белые руки и ноги раскинуты.
      </p>
      <p>Он зовет старика, но тот не может его слышать.</p>
      <p>Он подбегает ближе.</p>
      <p>ФОГОРН снова ревет.</p>
      <p>ЖЕНЩИНА, кажется, МЕРТВА, запуталась в водорослях.</p>
      <p>МОЛОДОЙ должен спасти ее, если сможет.</p>
      <p>МОЛОДОЙ встает на колени...</p>
      <p>Убирает водоросли с ее лица...</p>
      <p>ОНА КРАСИВА. Самая красивая женщина, которую он когда-либо видел.</p>
      <p>
        Кровь приливает к его голове. Сердце стучит. Он осматривает<br/>
        ее. Хочет прикоснуться. Колеблется... но делает это.
      </p>
      <p>Он проверяет ее пульс...</p>
      <p>Прикладывает голову к ее груди: мертва.</p>
      <p>Медленно он касается ее щеки, затем губ...</p>
      <p>
        Он проводит рукой по ее телу, в ужасе и горе<br/>
        о ее смерти, но в то же время очарован ее красотой, ее идеальной<br/>
        женственной фигурой... Он пробирается мимо ее груди, к ее<br/>
        ребрам...
      </p>
      <p>
        Кажется, на ее ребрах есть раны -- глубокие порезы. Они<br/>
        не окровавлены. Они выглядят почти как... <u>ЖАБРЫ</u>.
      </p>
      <p>
        Он проводит рукой мимо ее талии, к ее гениталиям, затем<br/>
        видит:
      </p>
      <p>У НЕЕ РЫБИЙ ХВОСТ! ОНА <u>РУСАЛКА</u>!!</p>
      <p>Он застывает в ужасе. Затем снова смотрит на ее лицо...</p>
      <p>Она открывает глаза и улыбается ему.</p>
      <p style={{ textAlign: "right" }}>46.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page45" />
        <ForwardLink href="/page47" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710315307/the-lighthouse-script/lhwgwq2ofj5zb8ijnc3x.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page47;
